export default function (text,textColor,skillColor){
   let reg = new RegExp(/<(color).*?>/g);
   let reg2 = new RegExp(/<(\/color).*?>/g);
   let reg3 = new RegExp(/<(buf).*?>/g);
   let reg4 = new RegExp(/<(\/buf).*?>/g);
   let reg5 = new RegExp(/_x005f/g);
   let reg6 = new RegExp(/\n/g);
   let reg7 = new RegExp(/·/g);
   let reg8 = new RegExp(/_x000D_/g);
   if (!text) return ''
   let result = text.replace(reg, `<span style="color: ${textColor ? textColor : ''}">`).replace(reg2, '</span>').replace(reg3, `<span style="color: ${skillColor ? skillColor : ''}">`).replace(reg4, '</span>').replace(reg5, '<br/>').replace(reg6, '<br/>').replace(reg7, '').replace(reg8, '')
   return result
}